<div class="text-center content">
  <h1>Failed to authenticate user.</h1>
  <h2>The login attempt failed.</h2>
  <h2>Please re-login from the launch application.</h2>
</div>
